import { render, staticRenderFns } from "./HerbalDetail.vue?vue&type=template&id=176b01be&scoped=true"
import script from "./HerbalDetail.vue?vue&type=script&lang=js"
export * from "./HerbalDetail.vue?vue&type=script&lang=js"
import style0 from "./HerbalDetail.vue?vue&type=style&index=0&id=176b01be&prod&scoped=true&lang=css"
import style1 from "./HerbalDetail.vue?vue&type=style&index=1&id=176b01be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176b01be",
  null
  
)

export default component.exports